<template>
	<div class="mt-2">
		<template v-if="loading">
			<v-progress-circular
				indeterminate
				color="primary"
				:size="40"
				width="2"
			></v-progress-circular>
		</template>
		<template v-else>
			<template v-if="messages == 'error'">
				Atsiprašome, šiuo metu vartotojų pranešimai nepasiekiami...
			</template>
			<template v-else>
				<v-data-table
					:headers="headers"
					:items="messages"
					locale="lt"
					:items-per-page="20"
				>
					<template v-slot:item.actions="{item}">
						<v-icon
							class="mr-2"
							@click="showMessage(item)"
							size="20"
							title="Pranešimo peržiūra"
						>
							mdi-note
						</v-icon>
						<v-icon
							@click="setResources(item)"
							size="20"
							title="Resursų skyrimas"
						>
							mdi-cogs
						</v-icon>
					</template>
				</v-data-table>
			</template>
		</template>
		<UserMessageDialog />
		<ResourcesDialog />
	</div>
</template>

<script>
	import AdminHelper from "../helpers/AdminHelper";
	import UserMessageDialog from "./UserMessageDialog";
	import ResourcesDialog from "./ResourcesDialog";

	export default {
		data: function(){
			var data = {
				loading: true,
				messages: null,
				headers: this.getHeaders()
			};
			return data;
		},
		components: {
			UserMessageDialog,
			ResourcesDialog
		},
		created(){
			this.getUserMessages();
		},
		methods: {
			getUserMessages: function(){
				this.loading = true;
				AdminHelper.getUserMessages().then(function(messages){
					messages.forEach(function(message){
						message["TypePretty"] = this.getTypePretty(message["Type"]);
						message["StatusPretty"] = this.getStatusPretty(message["Status"]);
					}.bind(this));
					this.loading = false;
					this.messages = messages;
				}.bind(this), function(){
					this.loading = false;
					this.messages = "error";
				}.bind(this));
			},
			getHeaders: function(){
				var headers = [{
					text: "ID",
					value: "ID"
				},{
					text: "Vartotojas",
					value: "User"
				},{
					text: "Tipas",
					value: "TypePretty"
				},{
					text: "Būsena",
					value: "StatusPretty"
				},{
					text: "Pranešimo data",
					value: "CreateDate"
				},{
					text: "Veiksmai",
					value: "actions",
					sortable: false
				}];
				return headers;
			},
			showMessage: function(item){
				this.$vBus.$emit("show-user-message", item);
			},
			setResources: function(item){
				this.$vBus.$emit("show-resources-dialog", item);
			},
			getTypePretty: function(type){
				return AdminHelper.getAttributeTitle(type);
			},
			getStatusPretty: function(status){
				return AdminHelper.getAttributeTitle(status);
			}
		}
	};
</script>

<style scoped>
	.v-data-table {
		max-width: 1000px;
	}
</style>